import React, { Ref } from 'react';
import { Button as AntdButton, ButtonProps } from 'antd';
import cn from 'classnames';
import styles from './ButtonIcon.styles.module.scss';

export interface IButtonIconProps {
  disabled?: boolean;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  onClick?: ButtonProps['onClick'];
  className?: string;
}

export const ButtonIcon = React.forwardRef(
  ({ disabled, children, icon, className, onClick }: IButtonIconProps, ref) => {
    return (
      <AntdButton
        ref={ref as Ref<HTMLElement>}
        onClick={onClick}
        className={cn(className, styles.root, styles.buttonIcon, {})}
        icon={icon ?? children}
        disabled={disabled}
      />
    );
  },
);
